import { Component, OnInit, Input } from '@angular/core';
import { ModalNavigationComponent } from '../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../services/gui/modal/modal-navigation.service';
import { UtilService } from '../../services/util.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContentShareFullDTO } from '../../services/api/api';

@Component({
  selector: 'sb-comp-planning-content-share',
  templateUrl: './sb-planning-content-share.component.html',
  styleUrls: ['./sb-planning-content-share.component.scss'],
  standalone: false,
})
export class SbPlanningContentShareComponent implements OnInit, ModalNavigationComponent {
  @Input() submissions: ContentShareFullDTO[];

  blockBackdrop: boolean;
  isInModalContext: boolean;

  form: FormGroup;
  editMode: boolean;
  namingState: boolean;

  constructor(
    public modal: ModalNavigationService,
    public util: UtilService
  ) {
    this.editMode = false;
    this.namingState = false;
    this.submissions = [];
    this.form = new FormGroup({
      Name: new FormControl('', Validators.required),
      Description: new FormControl(''),
    });
  }

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.submissions = this.modal.getCurrentNavigation().data.submissions;
      this.editMode = true;
    }
  }

  ok() {
    if (this.isInModalContext) {
      if (this.editMode && !this.namingState) {
        this.namingState = true;
      } else if (this.editMode && this.namingState) {
        this.modal.result({ name: this.Name.value, description: this.Description.value });
      }
    }
  }

  cancel() {
    if (this.isInModalContext) {
      this.modal.result(null);
    }
  }

  deleteContentShareFromSubmission(i: number) {
    if (i <= this.submissions.length) {
      this.submissions.splice(i, 1);
    }
    if (this.submissions.length === 0) {
      this.cancel();
    }
  }
}
